import { getAppInit } from "@/api/apiclient/config";
import { defineStore } from "pinia";
import { useFavicon } from "@vueuse/core";

export interface Meta {
  id: string;
  title: string;
  description: string;
  favicon: string;
  logo: string;
  name: string;
  privacyCookieCode: number;
}

export const useConfig = defineStore("meta", {
  state: () => ({
    meta: {} as Meta,
  }),
  actions: {
    async init(): Promise<void> {
      const response = await getAppInit();
      this.meta.id = response?.id;
      this.meta.title = response?.title;
      this.meta.description = response?.description;
      this.meta.favicon = response?.favicon;
      this.meta.logo = response?.logo;
      this.meta.name = response?.name;
      this.meta.privacyCookieCode = response?.privacyCookieCode;

      const icon = useFavicon()
      icon.value = this.meta.favicon;
    },
  },
});
